import { render, staticRenderFns } from "./CartsList.vue?vue&type=template&id=77b4effa&scoped=true"
import script from "./CartsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartsList.vue?vue&type=style&index=0&id=77b4effa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4effa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartsListEmpty: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsListEmpty.vue').default,CartsListItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsListItem.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,CBtnSecondary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnSecondary/CBtnSecondary.vue').default,CartsModal: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsModal.vue').default})
